import { ReadingTextRow } from '@/components/languages/ReadingTextRow'
import { useStaggerIn } from '@/hooks/useStaggerIn'
import { DIFFICULTY_LEVELS } from '@/types/reading'
import type { Reading } from '@/types/reading'
import type { CefrFilter } from '@/components/languages/CefrFilterBar'

interface ReadingTextListProps {
  readings: Reading[]
  filter: CefrFilter
}

function filtered(readings: Reading[], filter: CefrFilter): Reading[] {
  const matches =
    filter === 'all' ? readings : readings.filter((r) => r.difficulty_level === filter)
  return [...matches].sort(
    (a, b) =>
      DIFFICULTY_LEVELS.indexOf(a.difficulty_level) - DIFFICULTY_LEVELS.indexOf(b.difficulty_level),
  )
}

/**
 * The filterable reading catalog (research D7). Filters by CEFR level and sorts ascending
 * by level. Shows a calm zero state when nothing matches.
 */
export function ReadingTextList({ readings, filter }: ReadingTextListProps) {
  const rows = filtered(readings, filter)
  const listRef = useStaggerIn<HTMLUListElement>(rows.length > 0)

  if (rows.length === 0) {
    return (
      <p className="py-16 text-center font-serif italic text-muted">
        No texts match yet.
      </p>
    )
  }

  return (
    <ul ref={listRef}>
      {rows.map((reading) => (
        <li key={reading.id}>
          <ReadingTextRow reading={reading} />
        </li>
      ))}
    </ul>
  )
}
